export default "__VITE_ASSET__CxKLRTnR__"